import { styled } from 'linaria/lib/react';
import React, { useEffect, useState } from 'react';
import { Flex, theme } from '@mtsbank/ui-kit';
export const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState<boolean>(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <WrapperButton onClick={scrollToTop} showButton={showButton} type="button">
      <Flex>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_5329_2758)">
            <path d="M6.254 20C5.13904 20 4.58067 18.6517 5.36906 17.8632L9.9588 13.2726C12.8067 10.4242 14.2306 9 16 9C17.7694 9 19.1934 10.4242 22.0412 13.2726L26.6309 17.8632C27.4193 18.6517 26.861 20 25.746 20C25.4141 20 25.0958 19.8681 24.861 19.6334L20.2713 15.0428C18.7974 13.5686 17.8662 12.6447 17.0979 12.0584C16.3874 11.5163 16.1174 11.5035 16 11.5035C15.8826 11.5035 15.6126 11.5163 14.9021 12.0584C14.1338 12.6447 13.2026 13.5686 11.7287 15.0428L7.13894 19.6334C6.90425 19.8681 6.58592 20 6.254 20Z" fill="#FAFAFA" />
          </g>
          <defs>
            <clipPath id="clip0_5329_2758">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </Flex>
    </WrapperButton>;
};
const WrapperButton = /*#__PURE__*/styled("button")({
  name: "WrapperButton",
  class: "wsxdha2",
  vars: {
    "wsxdha2-1": [({
      showButton
    }) => showButton ? 'flex' : 'none']
  }
});

require("./ScrollToTopButton.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./ScrollToTopButton.tsx");